enum PaymentMethodStatusCodeEnum {
    ACTIVE = "ACTIVE",
    EXPIRES_NEXT_MONTH = "EXPIRES_NEXT_MONTH",
    EXPIRES_THIS_MONTH = "EXPIRES_THIS_MONTH",
    EXPIRED = "EXPIRED",
    REVOKED = "REVOKED",
}

export default PaymentMethodStatusCodeEnum;
